const html = '<div id="roomTourModal" class="room-type__dialog">'
  + '<button type="button" class="room-type__dialog__button">'
  + '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 50 50">'
  + '<path d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z"></path>'
  + '</svg>'
  + '</button>'
  + '<div class="room-type__dialog__wrapper">'
  + '<iframe id="iframeContent" src="" frameborder="0"></iframe>'
  + '</div>'
  + '</div>'
  + '<div id="roomTourOverlay" class="room-type__dialog__overlay"></div>';

function creatModal() {
  document.querySelector('main').insertAdjacentHTML('beforeend', html);
}

function openModal(url) {
  document.getElementById('iframeContent').src = url;
  document.getElementById('roomTourModal').style.display = 'block';
  document.getElementById('roomTourOverlay').style.display = 'block';
  document.body.classList.add('overflow-hidden');
}

function closeModal() {
  document.getElementById('roomTourModal').style.display = 'none';
  document.getElementById('roomTourOverlay').style.display = 'none';
  document.getElementById('iframeContent').src = '';
  document.body.classList.remove('overflow-hidden');
}

const roomTourLink = '.room-type__link--tour';

if (document?.querySelector(roomTourLink)) {
  creatModal();
  const roomTourCloseBtn = '.room-type__dialog__button';

  document.querySelectorAll(roomTourLink).forEach((item) => {
    item?.addEventListener('click', (e) => {
      e.preventDefault();
      const iframeLink = e.target.href;
      openModal(iframeLink);
    });
  });

  document.querySelector(roomTourCloseBtn).addEventListener('click', closeModal);
  document.querySelector('.room-type__dialog__overlay').addEventListener('click', closeModal);

  window.addEventListener('click', (event) => {
    if (event.target === document.getElementById('roomTourModal')) {
      closeModal();
    }
  });
}
